var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"update-modal-mask"},[_c('div',{staticClass:"update-modal-dialog"},[_c('img',{staticClass:"button",attrs:{"src":require("@/assets/images/update-system-button.png"),"alt":""},on:{"click":_vm.refresh}})])])}
var staticRenderFns = []

export { render, staticRenderFns }